export const RESPONSIVE_TOOLBAR = 'nav:responsiveToolbar';
export const PLPO_GATE = 'ProductLedProOnboardingUnboxingFlow:SpringSpotlight';
export const USER_INVITE_MODAL_GATE = 'UserSetup:UserInviteModal';
export const CALLING_REDESIGN_GATE = 'Calling:Rep:Redesign';
export const GH_TOUR_GATE = 'nav:gh:nav-gh-onboarding-tour';
export const TOP_NAV_ACTIVE_STATE = 'nav:top-nav-active-state';
export const BREEZE_ASSISTANT_REBRAND = 'BreezeAssistant:Rebrand:2025';
export const I18N_GATE = 'nav:i18n';